export const PERMISSIONS = {
  FRONT_READ: 'FRONT_READ',
  DASHBOARD_READ: 'DASHBOARD_READ',
    INSPECTION_WRITE: 'INSPECTION_WRITE',

    CONSTANT_INSPECTION_WRITE: 'CONSTANT_INSPECTION_WRITE',
    
    ALERT_DELETE: 'ALERT_DELETE',
    
    ATTENTION_OBSERVATION_WRITE: 'ATTENTION_OBSERVATION_WRITE',
    ATTENTION_OBSERVATION_RELEASE: 'ATTENTION_OBSERVATION_RELEASE',
    ATTENTION_OBSERVATION_DELETE: 'ATTENTION_OBSERVATION_DELETE,',
    
    MAINTENANCE_TASK_WRITE: 'MAINTENANCE_TASK_WRITE',
    MAINTENANCE_TASK_CONFIRM: 'MAINTENANCE_TASK_CONFIRM,',
    MAINTENANCE_TASK_DELETE: 'MAINTENANCE_TASK_DELETE,',

    DASHBOARD_ALRAM_READ: 'DASHBOARD_ALRAM_READ',
    DASHBOARD_ALRAM_RELEASE: 'DASHBOARD_ALRAM_RELEASE',

    EQUIPMENT_IMAGE_MODIFY: 'EQUIPMENT_IMAGE_MODIFY',
    EQUIPMENT_REMARK_MODIFY: 'EQUIPMENT_REMARK_MODIFY',
    EQUIPMENT_CHECK_LIST_MODIFY: 'EQUIPMENT_CHECK_LIST_MODIFY',
    EQUIPMENT_PART_REPLACE:'EQUIPMENT_PART_REPLACE',

    EQUIPMENT_CATEGORY_SEARCH:'EQUIPMENT_CATEGORY_SEARCH',

  SETTING_READ: 'SETTING_READ',
    SETTING_EQUIPMENT_CATEGORY_MNG_READ: 'SETTING_EQUIPMENT_CATEGORY_MNG_READ',
        SETTING_EQUIPMENT_READ: 'SETTING_EQUIPMENT_READ',
        SETTING_EQUIPMENT_WRITE: 'SETTING_EQUIPMENT_WRITE',
        SETTING_EQUIPMENT_CATEGORY_READ: 'SETTING_EQUIPMENT_CATEGORY_READ',
        SETTING_EQUIPMENT_STATUS_STANDARD_READ: 'SETTING_EQUIPMENT_STATUS_STANDARD_READ',
        SETTING_EQUIPMENT_CHECK_LIST_READ: 'SETTING_EQUIPMENT_CHECK_LIST_READ',

    SETTING_COMPANY_USER_READ: 'SETTING_COMPANY_USER_READ',
    SETTING_USER_READ: 'SETTING_USER_READ',
    SETTING_IOT_READ: 'SETTING_IOT_READ',
    SETTING_DATAROOM_READ: 'SETTING_DATAROOM_READ',
    SETTING_DATAROOM_WRITE: 'SETTING_DATAROOM_WRITE',
    SETTING_DATAROOM_MODIFY_DELETE: 'SETTING_DATAROOM_MODIFY_DELETE',
    SETTING_ACCESS_LOG_READ: 'SETTING_ACCESS_LOG_READ'
};

export const ROLE_PERMISSIONS = {
  /******************** 시스템 사용자 **********************/
  /** 시스템관리자 **/
  SA: [
    PERMISSIONS.FRONT_READ,
    PERMISSIONS.DASHBOARD_READ,
        PERMISSIONS.INSPECTION_WRITE,
        PERMISSIONS.CONSTANT_INSPECTION_WRITE,

        PERMISSIONS.ALERT_DELETE,

        PERMISSIONS.ATTENTION_OBSERVATION_WRITE,
        PERMISSIONS.ATTENTION_OBSERVATION_RELEASE,
        PERMISSIONS.ATTENTION_OBSERVATION_DELETE,

        PERMISSIONS.MAINTENANCE_TASK_WRITE,
        PERMISSIONS.MAINTENANCE_TASK_CONFIRM,
        PERMISSIONS.MAINTENANCE_TASK_DELETE,

        PERMISSIONS.DASHBOARD_ALRAM_READ,
        PERMISSIONS.DASHBOARD_ALRAM_RELEASE,

        PERMISSIONS.EQUIPMENT_IMAGE_MODIFY,
        PERMISSIONS.EQUIPMENT_REMARK_MODIFY,
        PERMISSIONS.EQUIPMENT_CHECK_LIST_MODIFY,
        PERMISSIONS.EQUIPMENT_PART_REPLACE,

        PERMISSIONS.EQUIPMENT_CATEGORY_SEARCH,

    PERMISSIONS.SETTING_READ,
        PERMISSIONS.SETTING_EQUIPMENT_CATEGORY_MNG_READ,
            PERMISSIONS.SETTING_EQUIPMENT_READ,
            PERMISSIONS.SETTING_EQUIPMENT_WRITE,
            PERMISSIONS.SETTING_EQUIPMENT_CATEGORY_READ,
            PERMISSIONS.SETTING_EQUIPMENT_STATUS_STANDARD_READ,
            PERMISSIONS.SETTING_EQUIPMENT_CHECK_LIST_READ,

        PERMISSIONS.SETTING_COMPANY_USER_READ,
        PERMISSIONS.SETTING_USER_READ,
        PERMISSIONS.SETTING_IOT_READ,
        PERMISSIONS.SETTING_DATAROOM_READ,
        PERMISSIONS.SETTING_DATAROOM_WRITE,
        PERMISSIONS.SETTING_DATAROOM_MODIFY_DELETE,
        PERMISSIONS.SETTING_ACCESS_LOG_READ
  ],

  /** 수집서버 **/
  CS: [
    PERMISSIONS.DASHBOARD_READ,
    
  ],

  /** 시스템 유지보수 엔지니어 **/
  SE: [
    PERMISSIONS.FRONT_READ,
    PERMISSIONS.DASHBOARD_READ,
        PERMISSIONS.INSPECTION_WRITE,
        PERMISSIONS.CONSTANT_INSPECTION_WRITE,

        PERMISSIONS.ATTENTION_OBSERVATION_WRITE,
        PERMISSIONS.ATTENTION_OBSERVATION_RELEASE,

        PERMISSIONS.MAINTENANCE_TASK_WRITE,

        PERMISSIONS.DASHBOARD_ALRAM_READ,
        PERMISSIONS.DASHBOARD_ALRAM_RELEASE,

        PERMISSIONS.EQUIPMENT_IMAGE_MODIFY,
        PERMISSIONS.EQUIPMENT_REMARK_MODIFY,
        PERMISSIONS.EQUIPMENT_CHECK_LIST_MODIFY,
        PERMISSIONS.EQUIPMENT_PART_REPLACE,
  ],

  /** 시스템 모니터링 운영자 **/
  SM: [
    PERMISSIONS.FRONT_READ,
    PERMISSIONS.DASHBOARD_READ,
        PERMISSIONS.INSPECTION_WRITE,
  ],
  
  /************** 업체사용자  *****************/
  /** 설비/작업관리자  **/
  AD: [
    PERMISSIONS.FRONT_READ,
    PERMISSIONS.DASHBOARD_READ,
        PERMISSIONS.INSPECTION_WRITE,
        PERMISSIONS.CONSTANT_INSPECTION_WRITE,

        PERMISSIONS.ATTENTION_OBSERVATION_WRITE,
        PERMISSIONS.ATTENTION_OBSERVATION_RELEASE,

        PERMISSIONS.MAINTENANCE_TASK_WRITE,

        PERMISSIONS.DASHBOARD_ALRAM_READ,
        PERMISSIONS.DASHBOARD_ALRAM_RELEASE,

        PERMISSIONS.EQUIPMENT_IMAGE_MODIFY,
        PERMISSIONS.EQUIPMENT_REMARK_MODIFY,
        PERMISSIONS.EQUIPMENT_CHECK_LIST_MODIFY,
        PERMISSIONS.EQUIPMENT_PART_REPLACE,

    PERMISSIONS.SETTING_READ,
    PERMISSIONS.DASHBOARD_READ,
        PERMISSIONS.SETTING_EQUIPMENT_CATEGORY_MNG_READ,
            PERMISSIONS.SETTING_EQUIPMENT_WRITE,
            PERMISSIONS.SETTING_EQUIPMENT_READ,

        PERMISSIONS.SETTING_COMPANY_USER_READ,
        PERMISSIONS.SETTING_DATAROOM_READ,
        PERMISSIONS.SETTING_DATAROOM_WRITE,
        PERMISSIONS.SETTING_DATAROOM_MODIFY_DELETE,
        PERMISSIONS.SETTING_ACCESS_LOG_READ
  ],

  /** 유지보수 엔지니어 **/
  WK: [
    PERMISSIONS.FRONT_READ,
    PERMISSIONS.DASHBOARD_READ,
        PERMISSIONS.INSPECTION_WRITE,
        PERMISSIONS.CONSTANT_INSPECTION_WRITE,

        PERMISSIONS.ATTENTION_OBSERVATION_WRITE,
        PERMISSIONS.ATTENTION_OBSERVATION_RELEASE,

        PERMISSIONS.MAINTENANCE_TASK_WRITE,

        PERMISSIONS.DASHBOARD_ALRAM_READ,
        PERMISSIONS.DASHBOARD_ALRAM_RELEASE,

        PERMISSIONS.EQUIPMENT_IMAGE_MODIFY,
        PERMISSIONS.EQUIPMENT_REMARK_MODIFY,
        PERMISSIONS.EQUIPMENT_CHECK_LIST_MODIFY,
        PERMISSIONS.EQUIPMENT_PART_REPLACE,
  ],

  /** 모니터링 운영자 **/
  MO: [
    PERMISSIONS.FRONT_READ,
    PERMISSIONS.DASHBOARD_READ,
        PERMISSIONS.INSPECTION_WRITE,
  ],
};